import React, { Component } from 'react';
import RiskIndicationDefinition from './../../constants/RiskIndicationDefinition';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import style from './style/riskindication.scss';

export default class Index extends Component {
    render() {
        const { score } = this.props;

        return (<div>
            <div className={ `${style.risk_single_indication_wrapper} ${score.score === RiskIndicationDefinition.LOW ? style.highLightedIndicationClass : ''}` }>
                <FontAwesomeIcon className={ style.low_speed_risk_icon } icon = { 'tachometer-alt' } />
                <p
                    className={ style.risk_indication_definition_text }
                    dangerouslySetInnerHTML={{ __html: score.lowLabel }}
                />
            </div>
            <div className={ `${style.risk_single_indication_wrapper} ${score.score === RiskIndicationDefinition.MIDDLE ? style.highLightedIndicationClass : ''}` }>
                <FontAwesomeIcon className={ style.mid_speed_risk_icon } icon= {'tachometer-alt'} />
                <p
                    className={ style.risk_indication_definition_text }
                    dangerouslySetInnerHTML={{ __html: score.middleLabel }}
                />
            </div>
            <div className={ `${style.risk_single_indication_wrapper} ${score.score === RiskIndicationDefinition.HIGH ? style.highLightedIndicationClass : ''}` }>
                <FontAwesomeIcon className={ style.high_speed_risk_icon } icon= {'tachometer-alt'} />
                <p
                    className={ style.risk_indication_definition_text }
                    dangerouslySetInnerHTML={{ __html: score.highLabel }}
                />
            </div>
        </div>);
    }
}
